'use client';

import React, { Suspense, useEffect } from 'react';
import { Providers } from './providers'; // Back to original providers
import { ChunkErrorBoundary } from '@/utils/dynamic-import-utils';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const handleRejection = (event: PromiseRejectionEvent) => {
        console.error("!!!! GLOBAL UNHANDLED REJECTION !!!!", event.reason);
        
        // Handle ChunkLoadError specifically
        if (event.reason?.name === 'ChunkLoadError' || 
            event.reason?.message?.includes('Loading chunk') ||
            event.reason?.message?.includes('Loading CSS chunk')) {
          console.log('ChunkLoadError detected, reloading page...');
          event.preventDefault(); // Prevent the default unhandled rejection behavior
          window.location.reload();
          return;
        }
    };

    const handleError = (event: ErrorEvent) => {
      console.error("!!!! GLOBAL ERROR !!!!", event.error);
      
      // Handle ChunkLoadError from regular errors too
      if (event.error?.name === 'ChunkLoadError' || 
          event.error?.message?.includes('Loading chunk') ||
          event.error?.message?.includes('Loading CSS chunk')) {
        console.log('ChunkLoadError detected via error event, reloading page...');
        window.location.reload();
        return;
      }
    };

    window.addEventListener('unhandledrejection', handleRejection);
    window.addEventListener('error', handleError);

    return () => {
        window.removeEventListener('unhandledrejection', handleRejection);
        window.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<div className="flex justify-center items-center h-screen">Loading application components...</div>}>
        <Providers>
          {children}
        </Providers>
      </Suspense>
    </ChunkErrorBoundary>
  );
}